import { Trans } from "react-i18next";

import ErrorLogo from "src/core/assets/images/error-logo.svg?react";

export const Error403 = () => {
  return (
    <div className="w-full flex flex-row items-center justify-center gap-x-20 pt-60px">
      <ErrorLogo />
      <div className="mt-10 font-light text-foreground text-lg">
        <Trans i18nKey="error.403" components={{ strong: <strong /> }} />
      </div>
    </div>
  );
};
